// @flow
const svgContainer: Element = document.createElement('div');

// necessário para fazer um forEach em elementos DOM para navegadores mais antigos
export function forEach(arr: NodeList<Node> | Array<any>, fn: Function): number {
  return Array.prototype.forEach.call(arr, fn);
}

const setSvg = (source: string): any => {
  svgContainer.innerHTML = source;

  return svgContainer.firstChild;
};

export const setSvgFill = (el: Node) => {
  forEach(el.childNodes, (node) => {
    if (node.nodeName === '#text') { return; }
    const fill = node.getAttribute('fill');
    if (fill && fill !== 'none') {
      node.removeAttribute('fill');
    }
  });
};

export const createSvgLegacy = (el: Element, source: string) => {
  const svg: Element = setSvg(source);

  while (svg.firstChild) {
    el.appendChild(svg.firstChild);
  }
};
